// extracted by mini-css-extract-plugin
export default {"Item":"menuItem_Item__veY+3","Content":"menuItem_Content__huRkZ","Title":"menuItem_Title__UmqxQ","SubItens":"menuItem_SubItens__8Si7H"};